import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import PcLayout from '@/components/layout/pc/Layout.vue'
import MobileLayout from '@/components/layout/mobile/Layout.vue'

Vue.use(VueRouter)

const pcRoutes: RouteConfig = {
	path: '/',
	component: PcLayout,
	meta: { roles: ['Student'] },
	children: [
		{
			path: '',
			name: 'Home',
			alias: 'Home',
			meta: { allowAnonymous: true },
			component: () => import('../views/pc/Home/Home.vue'),
		},
		{
			path: 'CourseSelection',
			name: 'course-selection',
			component: () => import('../views/pc/CourseSelection/CourseSelection.vue'),
		},
		{
			path: 'ActiveUser',
			name: 'active-user',
			meta: { allowAnonymous: true },
			component: () => import('../views/pc/ActiveUser/ActiveUser.vue'),
		},
	],
}

const PcCourseTimePeriod: RouteConfig = {
	path: '/CourseTimePeriod/:classId',
	name: 'course-time-period',
	meta: { allowAnonymous: true },
	component: () => import('../views/pc/CourseTimePeriod/CourseTimePeriod.vue'),
	props: route => ({
		classId: route.params.classId,
	}),
}

const mobileRoutes: RouteConfig = {
	path: '/mobile',
	component: MobileLayout,
	meta: { roles: ['Student'] },
	children: [
		{
			path: '',
			name: 'mobile-home',
			meta: { allowAnonymous: true },
			component: () => import('../views/mobile/Home/Home.vue'),
		},
		{
			path: 'CourseSelection',
			name: 'mobile-course-selection',
			component: () => import('../views/mobile/CourseSelection/CourseSelection.vue'),
		},
		{
			path: 'ActiveUser',
			name: 'mobile-active-user',
			meta: { allowAnonymous: true },
			component: () => import('../views/mobile/ActiveUser/ActiveUser.vue'),
		},
	],
}

const MobileCourseTimePeriod: RouteConfig = {
	path: '/mobile/CourseTimePeriod/:classId',
	name: 'mobile-course-time-period',
	meta: { allowAnonymous: true },
	component: () => import('../views/mobile/CourseTimePeriod/CourseTimePeriod.vue'),
	props: route => ({
		classId: route.params.classId,
	}),
}

const router = new VueRouter({
	routes: [pcRoutes, mobileRoutes, PcCourseTimePeriod, MobileCourseTimePeriod],
})

export default router
